import { ModelBase, observable } from "@shoothill/core";
import { action, computed } from "mobx";
import moment from "moment";
export class PotentialProgrammeDelaysModel extends ModelBase<PotentialProgrammeDelaysModel> {
    public static readonly DEFAULT_ID = null;
    public static readonly DEFAULT_PROJECT_ID = "";
    public static readonly DEFAULT_OTHER_PROGRAMME_NOTE = "";
    public static readonly DEFAULT_POTENTIAL_PROGRAMME_DELAYS_PHOTOS = [];
    public static readonly DEFAULT_ASSIGN_TO_USER_ID = "";
    public static readonly DEFAULT_CREATED_BY_USER_ID = "";
    public static readonly DEFAULT_CREATED_DATE = new Date();
    public static readonly DEFAULT_IS_DELETED = false;
    public static readonly DEFAULT_LAST_UPDATED_BY_USER_ID = "";
    public static readonly DEFAULT_LAST_UPDATED_DATE = "";
    public static readonly DEFAULT_ROW_VERSION = "";

    @observable
    public id: string | null = PotentialProgrammeDelaysModel.DEFAULT_ID;

    @observable
    public projectId: string | null = PotentialProgrammeDelaysModel.DEFAULT_PROJECT_ID;

    @observable
    public potentialProgrammeNote: string | null = PotentialProgrammeDelaysModel.DEFAULT_OTHER_PROGRAMME_NOTE;

    @observable
    public potentialProgrammeDelaysPhotos: PotentialProgrammeDelaysPhotosFile[] = PotentialProgrammeDelaysModel.DEFAULT_POTENTIAL_PROGRAMME_DELAYS_PHOTOS;

    @observable
    public assignToUserId: string | null = PotentialProgrammeDelaysModel.DEFAULT_ASSIGN_TO_USER_ID;

    @observable
    public createdByUserId: string | null = PotentialProgrammeDelaysModel.DEFAULT_CREATED_BY_USER_ID;

    @observable
    public createdDate: any = PotentialProgrammeDelaysModel.DEFAULT_CREATED_DATE;

    @observable
    public isDeleted: boolean = PotentialProgrammeDelaysModel.DEFAULT_IS_DELETED;

    @observable
    public lastUpdatedByUserId: string | null = PotentialProgrammeDelaysModel.DEFAULT_LAST_UPDATED_BY_USER_ID;

    @observable
    public lastUpdatedDate: string | null = PotentialProgrammeDelaysModel.DEFAULT_LAST_UPDATED_DATE;

    @observable
    public rowVersion: string | null = PotentialProgrammeDelaysModel.DEFAULT_ROW_VERSION;

    @computed
    public get hasId(): boolean {
        return this.id !== null && this.id !== undefined && this.id !== "";
    }

    @computed
    public get formattedLastUpdatedDate(): string {
        return moment(this.lastUpdatedDate).format("DD/MM/YYYY @ HH:mm");
    }

    @action
    public fromDto(dto: PotentialProgrammeDelaysDTO): void {
        for (let key in dto) {
            if (dto.hasOwnProperty(key)) {
                if (this[key] instanceof Date) {
                    this[key] = new Date(dto[key]);
                } else {
                    this[key] = dto[key];
                }
            }
        }
    }

    @action
    public fromPotentialProgrammeDelaysPhotosFileDTO(dto: PotentialProgrammeDelaysPhotosFile[]): void {
        let processedPhotos: PotentialProgrammeDelaysPhotosFile[] = [];
        for (const photo of dto) {
            processedPhotos.push(photo);
        }
        this.potentialProgrammeDelaysPhotos = processedPhotos;
    }

    @action
    public toDto() {
        const PotentialProgrammeDelaysModel: PotentialProgrammeDelaysDTO = {
            id: this.id,
            projectId: this.projectId,
            potentialProgrammeNote: this.potentialProgrammeNote,
            assignToUserId: this.assignToUserId,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate,
            isDeleted: this.isDeleted,
            lastUpdatedByUserId: this.lastUpdatedByUserId,
            lastUpdatedDate: this.lastUpdatedDate,
            rowVersion: this.rowVersion,
        };

        return PotentialProgrammeDelaysModel;
    }

    @action
    public reset = () => {
        this.id = PotentialProgrammeDelaysModel.DEFAULT_ID;
        this.projectId = PotentialProgrammeDelaysModel.DEFAULT_PROJECT_ID;
        this.potentialProgrammeNote = PotentialProgrammeDelaysModel.DEFAULT_OTHER_PROGRAMME_NOTE;
        this.assignToUserId = PotentialProgrammeDelaysModel.DEFAULT_ASSIGN_TO_USER_ID;
        this.potentialProgrammeDelaysPhotos = PotentialProgrammeDelaysModel.DEFAULT_POTENTIAL_PROGRAMME_DELAYS_PHOTOS;
    };

    // #Start Custome Validation

    @computed
    public get validatePotentialProgrammeNote(): string {
        return this.potentialProgrammeNote === PotentialProgrammeDelaysModel.DEFAULT_OTHER_PROGRAMME_NOTE ? "Please enter a note" : "";
    }

    @computed
    public get validateAssignToUserId(): string {
        return this.assignToUserId === PotentialProgrammeDelaysModel.DEFAULT_ASSIGN_TO_USER_ID ? "Please select a assign to" : "";
    }

    // #End Custome Validation
}

export interface PotentialProgrammeDelaysDTO {
    id: string | null;
    projectId: string | null;
    potentialProgrammeNote: string | null;
    assignToUserId: string | null;
    createdByUserId: string | null;
    createdDate: string | null;
    isDeleted: boolean;
    lastUpdatedByUserId: string | null;
    lastUpdatedDate: string | null;
    rowVersion: string | null;
}

export interface PotentialProgrammeDelaysPhotosFile {
    id: string | null;
    potentialProgrammeDelaysId: string | null;
    fileName: string;
    photoURL: string;
    createdByUserId: string | null;
    isDeleted: boolean;
    createdDate: string | null;
}

export interface AssignToUsersDTO {
    id: string;
    displayName: string;
}

export interface UpsertPotentialProgrammeDelaysRequestDTO {
    potentialProgrammeDelays: PotentialProgrammeDelaysDTO;
    potentialProgrammeDelaysPhotos: PotentialProgrammeDelaysPhotosFile[];
}

export interface UpsertPotentialProgrammeDelaysResponseDTO {
    potentialProgrammeDelays: PotentialProgrammeDelaysDTO;
    potentialProgrammeDelaysUsers: AssignToUsersDTO[];
    potentialProgrammeDelaysPhotos: PotentialProgrammeDelaysPhotosFile[];
}

export interface PotentialProgrammeDelaysByIdResponseDTO {
    potentialProgrammeDelays: PotentialProgrammeDelaysDTO;
    potentialProgrammeDelaysList: PotentialProgrammeDelaysDTO[];
    potentialProgrammeDelaysUsers: AssignToUsersDTO[];
    potentialProgrammeDelaysPhotos: PotentialProgrammeDelaysPhotosFile[];
}

export interface PotentialProgrammeDelaysResponseDTO {
    potentialProgrammeDelays: PotentialProgrammeDelaysDTO;
    potentialProgrammeDelaysList: PotentialProgrammeDelaysDTO[];
    potentialProgrammeDelaysUsers: AssignToUsersDTO[];
    potentialProgrammeDelaysPhotos: PotentialProgrammeDelaysPhotosFile[];
}

export interface PotentialProgrammeDelaysRequestDTO {
    date: string | null;
    projectId: string | null;
    formId: string | null;
}
